export const DownloadUtil = {
  downloadFile(blob: Blob, fileName: string): void {
    if (!blob) return;
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(objectUrl);
  },
};
